module.exports = __webpack_public_path__ + "img/logo_big.7d4ee30e.png";